import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */
i18next.addResources(locales.EN, 'LANDING_PAGE', {
  HERO_TITLE: 'Beneemeth',
  HERO_SUBTITLE: 'Your comprehensive platform for community procedures and services management.',
  ABOUT_TITLE: 'About Us',
  ABOUT_P1:
    'Beneemeth is a technological solution designed to centralize and streamline our community administrative processes. We facilitate interaction between users and institutions, ensuring security and efficiency.',
  ABOUT_P2:
    'From cemetery space reservations to life cycle certifications and procedures, our platform provides digital support and clarity when families need it most.',
  CONTACT_TITLE: 'Any questions?',
  CONTACT_SUBTITLE: 'Fill out the form and an advisor will contact you shortly.',
});

/* ------------------------------------- Spanish ------------------------------------- */
i18next.addResources(locales.ES, 'LANDING_PAGE', {
  HERO_TITLE: 'Beneemeth',
  HERO_SUBTITLE: 'Tu plataforma integral para la gestión de trámites y servicios comunitarios.',
  ABOUT_TITLE: 'Sobre Nosotros',
  ABOUT_P1:
    'Beneemeth es la solución tecnológica diseñada para centralizar y agilizar los procesos administrativos de nuestra comunidad. Facilitamos la interacción entre los usuarios y las instituciones, garantizando seguridad y eficiencia en cada gestión.',
  ABOUT_P2:
    'Desde la reserva de espacios en cementerios hasta la gestión de certificaciones y trámites de ciclo de vida, nuestra plataforma acompaña a las familias brindando claridad y soporte digital en los momentos que más lo necesitan.',
  CONTACT_TITLE: '¿Tienes dudas?',
  CONTACT_SUBTITLE:
    'Completa el formulario y un asesor se pondrá en contacto contigo a la brevedad.',
});
